import { createFileRoute } from "@tanstack/react-router";
import { TenantDetailPage } from "@/components/admin/TenantDetailPage";

export const Route = createFileRoute("/admin/tenants/$tenantId")({
  component: TenantDetailPage,
});
